module.exports = __webpack_public_path__ + "img/portraits_19_V.c82799c1.webp";